import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/global.d.ts').Background}
 */
const Background = ({
    image = null,
    video = null
}) => {
    return (
        <figure
            aria-hidden='true'
            className='fixed inset-0 -z-10 bg-neutral-950 pointer-events-none select-none'>
            {image && (
                <img
                    className='h-full w-full object-cover object-center'
                    height={image.height}
                    loading='eager'
                    src={image.px2}
                    width={image.width} />
            )}

            {video && (
                <video
                    autoPlay
                    disablePictureInPicture
                    loop
                    muted
                    playsInline
                    className='h-full w-full object-cover object-center'
                    height={video.height}
                    loading='eager'
                    src={video.src}
                    width={video.width} />
            )}
        </figure>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Background;
